import { createContext, useContext, useState, useEffect } from 'react';
import { fetchBlogPageData } from './pageDataService';

const BlogDataContext = createContext(null);

export const BlogDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_blog_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchBlogPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_blog_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache blog data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <BlogDataContext.Provider value={{ data, isLoading }}>
      {children}
    </BlogDataContext.Provider>
  );
};

export const useBlogData = () => {
  const context = useContext(BlogDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
